import { Select } from '@/ui'
import type { CompositionSlot, AvailableSectionGroup, SlotSelection } from './types'
import styles from '../TemplateCompose.module.css'

interface Props {
  slots: CompositionSlot[]
  availableSections: AvailableSectionGroup[]
  selection: SlotSelection
  onChange: (sectionType: string, sectionDesignId: string) => void
}

/** shell 슬롯(물리 순) 목록. 각 슬롯은 같은 sectionType 후보 드롭다운으로 채운다. */
export function SlotList({ slots, availableSections, selection, onChange }: Props) {
  const bySectionType = new Map(availableSections.map((g) => [g.sectionType, g.designs]))

  return (
    <div className={styles.slotList}>
      {slots.map((slot) => {
        const candidates = bySectionType.get(slot.sectionType) ?? []
        // 모든 슬롯을 비워둘 수 있다(빈 슬롯 = 그 섹션이 없는 템플릿).
        const options = [
          { value: '', label: '— 비움 (이 섹션 없음) —' },
          ...candidates.map((d) => ({ value: d.id, label: `${d.name} (${d.slug})` })),
        ]
        const current = selection[slot.sectionType] ?? ''
        return (
          <div key={slot.sectionType} className={styles.slotCard}>
            <div className={styles.slotHeader}>
              <span className={styles.slotIndex}>#{slot.sortOrder + 1}</span>
              <span className={styles.slotType}>{slot.sectionType}</span>
            </div>
            <Select
              options={options}
              value={current}
              onChange={(e) => onChange(slot.sectionType, e.target.value)}
            />
            {candidates.length === 0 && (
              <p className={styles.slotWarn}>이 타입({slot.sectionType})의 라이브러리 섹션이 없습니다</p>
            )}
          </div>
        )
      })}
    </div>
  )
}
